import React, { useEffect, useRef, useState } from "react";
import withLayout from "../../hocs/Layout";
import { findInObjArr } from "../../helpers/UtilityHelper";
import {
    apiConstants,
    post,
    get,
    postMultipart,
    getDownload,
    //   getDownload,
} from "../../common/constants";
import "./location.css";
import Loader from "../../common/Loader";
import {
    Alert,
    Button,
    ButtonGroup,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import { useSnackbar } from "notistack";
import {
    AddCircleRounded,
    DownloadRounded,
    UploadFileRounded,
    Edit as EditIcon,
    LocationOn as LocationIcon,
    Phone as PhoneIcon,
    Email as EmailIcon,
    Business as BusinessIcon,
    Store as StoreIcon
} from "@mui/icons-material";
import { MerchantFilterCached } from "../../common/ProshipFormComponents";
import { useForm } from "react-hook-form";
import { FormProvider } from "../../common/hook-form"
import PageTitle from "../PageTitle";
import AddDeliveryLocation from "./AddDeliveryLocation";
import { FilterLocation } from "./Filter";
import SideDrawer from "../SideDrawer";


export function MerchantDeliveryLocations() {
    const [show, setShow] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentId, setCurrentId] = useState();
    const [page, setPage] = useState(0);
    const [merchant, setMerchant] = useState();
    const [sizePerPage, setSizePerPage] = useState(10);
    const [deliveryLocation, setDelLocation] = useState([]);
    const [filteredLocationList, setFilteredLocationList] = useState([]);
    const [hasLoadedOnce , setHasLoadedOnce] = useState(false);
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [failedOrders, setFailedOrders] = useState([]);
    const [uploadResponse, setUploadResponse] = useState(null);
    const bulkUploadRef = useRef();

    const { enqueueSnackbar } = useSnackbar();
    const methods = useForm({
        defaultValues: {
            merchant: '',
        }
    });
    const { reset, watch } = methods


    const handleClose = () => {
        setShow(false);
    };

    const handleShow = () => {
        if (merchant) {
            setShow(true)
        } else {
            enqueueSnackbar("Please select a Merchant!", { variant: "error" });
        }
    };
    const column = [
        {
            headerName: "Name",
            field: "name",
            flex: 1,
            minWidth: 150,
            headerAlign: "left",
            renderHeader: () => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <BusinessIcon fontSize="small" sx={{ color: "text.secondary" }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Name</Typography>
                </Box>
            ),
            renderCell: ({ row }) => (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {row.name}
                </Typography>
            ),
        },
        {
            headerName: "Drop Name",
            field: "dropOrganization",
            flex: 1,
            minWidth: 150,
            headerAlign: "left",
            renderHeader: () => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <StoreIcon fontSize="small" sx={{ color: "text.secondary" }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Drop Name</Typography>
                </Box>
            ),
            renderCell: ({ row }) => (
                <Typography variant="body2">
                    {row.dropOrganization || "-"}
                </Typography>
            ),
        },
        {
            headerName: "Address",
            field: "pincode",
            flex: 1.5,
            minWidth: 200,
            headerAlign: "left",
            renderHeader: () => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <LocationIcon fontSize="small" sx={{ color: "text.secondary" }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Address</Typography>
                </Box>
            ),
            renderCell: ({ row }) => {
                const addArr = [];
                if (row.address_line) addArr.push(row.address_line);
                if (row.city) addArr.push(row.city);
                if (row.state) addArr.push(row.state);
                if (row.pincode) addArr.push(row.pincode);
                if (row.country) addArr.push(row.country);
                const address = addArr.join(", ");
                return (
                    <Tooltip title={address} arrow>
                        <Typography
                            variant="body2"
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%",
                                color: "text.secondary"
                            }}
                        >
                            {address || "-"}
                        </Typography>
                    </Tooltip>
                );
            },
        },
        {
            headerName: "Contact No",
            field: "contactNumber",
            flex: 1,
            minWidth: 130,
            headerAlign: "left",
            renderHeader: () => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <PhoneIcon fontSize="small" sx={{ color: "text.secondary" }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Contact No</Typography>
                </Box>
            ),
            renderCell: ({ row }) => (
                <Typography variant="body2">
                    {row.contactNumber || "-"}
                </Typography>
            ),
        },
        {
            headerName: "Email",
            field: "email",
            flex: 1,
            minWidth: 180,
            headerAlign: "left",
            renderHeader: () => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <EmailIcon fontSize="small" sx={{ color: "text.secondary" }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Email</Typography>
                </Box>
            ),
            renderCell: ({ row }) => (
                <Typography
                    variant="body2"
                    sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: "100%"
                    }}
                >
                    {row.email || "-"}
                </Typography>
            ),
        },
        {
            headerName: "GSTIN",
            field: "gstin",
            flex: 1,
            minWidth: 140,
            headerAlign: "left",
            renderCell: ({ row }) => (
                <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
                    {row.gstin || "-"}
                </Typography>
            ),
        },
        {
            headerName: "Actions",
            field: "action",
            flex: 0.8,
            minWidth: 100,
            headerAlign: "center",
            align: "center",
            sortable: false,
            renderCell: ({ row }) => {
                return (
                    <Tooltip title="Edit Delivery Location" arrow>
                        <IconButton
                            onClick={() => handleEditClick(row.id)}
                            size="small"
                            sx={{
                                color: "primary.main",
                                "&:hover": {
                                    backgroundColor: "primary.light",
                                    transform: "scale(1.1)",
                                },
                                transition: "all 0.2s ease-in-out"
                            }}
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
    ]

    const addDeliveryLocation = (param) => {
        setFormLoading(true);
        const addressCopy = Object.assign(
            {},
            { status: "ACTIVE", address_type: "PICKUP", country: "India" },
            currentId,
            param
        );
        post(
            `${apiConstants.ADD_DELIVERY_LOCATION}/${merchant}`,
            addressCopy
        )
            .then((response) => {
                setFormLoading(false);
                handleClose();
                loadLocation(merchant);
            })
            .catch((err) => {
                console.error(err);
                setFormLoading(false);
            });
    };

    const loadLocation = (id) => {
        setLoading(true);
        get(`${apiConstants.DELIVERY_LOCATION}/${id}`)
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    setDelLocation(response.data);
                } else {
                    setDelLocation([])
                }
            })
            .catch((err) => {
                console.error(err);
            }).finally(() => {
                setLoading(false);
                setHasLoadedOnce(true);
            });
    };

    const handleDownloadSampleClick = () => {
        setLoading(true);
        getDownload(
            `${apiConstants.BASE_LOCAL}${apiConstants.DOWNLOAD_SAMPLE_LOCATION}?fileName=BULK_DELIVERY_LOC_UPLOAD`
            // BULK_DELIVERY_LOC_UPLOAD_NO_MER_ID
        )
            .then((response) => {
                setLoading(false);
                const binaryData = [];
                binaryData.push(response.data);
                const href = URL.createObjectURL(
                    new Blob(binaryData, { type: "application/octet-stream" })
                );
                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "delivery-location.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    const parseFailedOrdersFromString = (dataString) => {
        if (!dataString || typeof dataString !== 'string') {
            return [];
        }
        
        let cleanedString = dataString.trim();
        if (cleanedString.startsWith('[') && cleanedString.endsWith(']')) {
            cleanedString = cleanedString.substring(1, cleanedString.length - 1);
        }
        
        const failedEntries = cleanedString.split(',').map(entry => entry.trim()).filter(entry => entry);
        
        return failedEntries.map((entry, index) => {
            const match = entry.match(/Failed:\s*(.+?)\s+Address:(.+?)(?:\s+Pin:(.+?))?$/i);
            
            if (match) {
                const reference = match[1] && match[1] !== 'null' ? match[1] : null;
                const address = match[2] || '';
                const pin = match[3] || '';
                
                let reason = `Address: ${address}`;
                if (pin) {
                    reason += ` Pin: ${pin}`;
                }
                
                return {
                    reference: reference || `Entry ${index + 1}`,
                    reason: reason || 'Unknown error'
                };
            } else {
                // Fallback: use the entire entry as reason
                return {
                    reference: `Entry ${index + 1}`,
                    reason: entry.replace(/^Failed:\s*/i, '') || 'Unknown error'
                };
            }
        });
    };

    const handleBulkUpload = (e) => {
        const param = e.target.files[0];
        if (!param) return;
        
        const formData = new FormData();
        formData.append("file", param);
        formData.append("fileName", param.name);
        setLoading(true);
        postMultipart(`${apiConstants.UPLOAD_DELIVERY_LOCATIONS}`, formData)
            .then((response) => {
                setLoading(false);
                if (typeof response?.data === 'string') {
                    const dataString = response.data;
                    if (dataString.includes('Failed:')) {
                        const parsedFailedOrders = parseFailedOrdersFromString(dataString);
                        setFailedOrders(parsedFailedOrders);
                        setUploadResponse({
                            status: 'COMPLETED',
                            fileName: param.name,
                            failedOrders: parsedFailedOrders
                        });
                        setErrorDialogOpen(true);
                        enqueueSnackbar("Some orders failed to upload. Please check the details.", { variant: "warning" });
                    } else if (dataString.length === 0 || dataString === '[]') {
                        enqueueSnackbar("Invalid file", { variant: "error" });
                    } else {
                        // Success case - remove brackets and show message
                        const successMessage = dataString.startsWith('[') && dataString.endsWith(']') 
                            ? dataString.substring(1, dataString.length - 1) 
                            : dataString;
                        enqueueSnackbar(successMessage, { variant: "success" });
                    }
                } 
                // Check if response.data is an object with failedOrders (pickup location format)
                else if (response?.data?.failedOrders?.length > 0) {
                    setFailedOrders(response.data.failedOrders);
                    setUploadResponse(response.data);
                    setErrorDialogOpen(true);
                    enqueueSnackbar("Some orders failed to upload. Please check the details.", { variant: "warning" });
                } 
                // Check if response.data is empty array
                else if (Array.isArray(response?.data) && response.data.length === 0) {
                    enqueueSnackbar("Invalid file", { variant: "error" });
                } 
                // Success case
                else {
                    const successMessage = typeof response.data === 'string' 
                        ? (response.data.startsWith('[') && response.data.endsWith(']') 
                            ? response.data.substring(1, response.data.length - 1) 
                            : response.data)
                        : 'Successfully uploaded!';
                    enqueueSnackbar(successMessage, { variant: "success" });
                }
                
                // Reset file input to allow uploading the same file again
                if (e.target) {
                    e.target.value = '';
                }
            })
            .catch((err) => {
                enqueueSnackbar("Could not be uploaded!", { variant: "error" });
                setLoading(false);
                // Reset file input even on error
                if (e.target) {
                    e.target.value = '';
                }
            });
    };

    const selectedMerchant = watch("merchant");

    useEffect(() => {
        if (selectedMerchant) {
            setHasLoadedOnce(false);
            loadLocation(selectedMerchant);
            setMerchant(selectedMerchant);
        }
    }, [selectedMerchant]);



    const handleAddClick = () => {
        setCurrentId(null);
        handleShow();
    };

    const handleEditClick = (id) => {
        const result = findInObjArr(deliveryLocation, id, "id");
        setCurrentId(result);
        handleShow();
    };

    const handleFilter = (filterValues) => {
        const { contactNumber, name } = filterValues;
        const filteredLocations = deliveryLocation.filter((location) => {
            const matchesContactNumber = contactNumber
                ? location.contactNumber.includes(contactNumber)
                : true;
            const matchesName = name
                ? location.name.toLowerCase().includes(name.toLowerCase())
                : true;
            return matchesContactNumber && matchesName;
        });
        setFilteredLocationList(filteredLocations);
    };

    useEffect(() => {
        setFilteredLocationList(deliveryLocation);
    }, [deliveryLocation]);

    const resetFilter = () => {
        setFilteredLocationList(deliveryLocation);
    };

    return (
        <>
            <PageTitle>Delivery Locations</PageTitle>
            {loading && <Loader />}
            {/* <MUIModal open={show} handleClose={handleClose} children={<AddDeliveryLocation show={show}
                formLoading={formLoading}
                handleClose={handleClose}
                handleData={addDeliveryLocation}
                currentId={currentId} />}
                title={`Add Delivery Location`} /> */}

                <SideDrawer
                    open={show}
                    setOpen={handleClose}
                    drawerWidth='70%'
                    title={currentId ? "Edit Delivery Location" : "Add Delivery Location"}
                    children={<AddDeliveryLocation show={show}
                        formLoading={formLoading}
                        handleClose={handleClose}
                        handleData={addDeliveryLocation}
                        currentId={currentId} />}
                />
            <input
                type="file"
                onChange={handleBulkUpload}
                ref={bulkUploadRef}
                style={{ display: "none" }}
            />
            <Card>
                <CardContent>
                    <FormProvider methods={methods}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4} style={{ overflow: 'hidden' }}>
                                <MerchantFilterCached />
                            </Grid>
                            <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Button type="button" variant="contained" color="error" size="small" onClick={() => {
                                    reset({
                                        merchant: '',
                                    })
                                    setMerchant()
                                    setDelLocation([])
                                    setHasLoadedOnce(false)
                                }}>Reset</Button>
                            </Grid>
                            {!merchant && (
                                <Grid item xs={12}>
                                    <Alert severity="info" sx={{ borderRadius: 1 }}>
                                        Please select a merchant to view their associated delivery locations.
                                    </Alert>
                                </Grid>
                            )}
                            {(merchant && filteredLocationList?.length === 0 && !loading && hasLoadedOnce) && (
                                <Grid item xs={12}>
                                    <Alert severity="error" sx={{ borderRadius: 1 }}>
                                        No delivery locations found for the selected merchant.
                                    </Alert>
                                </Grid>
                            )}
                        </Grid>
                    </FormProvider>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Box
                                sx={{
                                    justifyContent: "flex-end",
                                    width: 1,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ButtonGroup
                                    sx={{
                                        "& button": {
                                            borderRight: "0 !important",
                                            color: "inherit",
                                            textTransform: "capitalize",
                                        },
                                    }}
                                    variant="text"
                                >
                                    <Button
                                        startIcon={<AddCircleRounded color="primary" />}
                                        type="button"
                                        color="primary"
                                        onClick={handleAddClick}
                                    >
                                        Add
                                    </Button>
                                    <Button
                                        startIcon={<UploadFileRounded color="warning" />}
                                        type="button"
                                        color="warning"
                                        // onClick={() => merchant ? bulkUploadRef.current.click() : enqueueSnackbar("Please select a Merchant before uploading.", { variant: "error" })}
                                        onClick={() => bulkUploadRef.current.click()}
                                    >
                                        Upload
                                    </Button>
                                    <Button
                                        startIcon={<DownloadRounded color="primary" />}
                                        type="button"
                                        color="warning"
                                        onClick={handleDownloadSampleClick}
                                    >
                                        Sample Download
                                    </Button>
                                </ButtonGroup>
                            </Box>
                        </Grid>
                    </Grid >
                </CardContent>
            </Card>
            {merchant &&
                <FilterLocation onFilter={handleFilter} resetFilter={resetFilter} />
            }
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <ProzoDataGrid
                        rows={filteredLocationList || []}
                        getRowId={(row) => row.id}
                        sizePerPage={sizePerPage}
                        setSizePerPage={setSizePerPage}
                        setPage={setPage}
                        page={page}
                        rowCount={filteredLocationList?.length || 0}
                        paginationMode={'client'}
                        columns={column}
                    />
                </Grid>
            </Grid>

            <Dialog
                open={errorDialogOpen}
                onClose={() => setErrorDialogOpen(false)}
                aria-labelledby="error-dialog-title"
                aria-describedby="error-dialog-description"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="error-dialog-title">
                    <Typography variant="h6" color="error">
                        Upload Issues Detected
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    {uploadResponse && (
                        <Box sx={{ mb: 2 }}>
                            {uploadResponse.status && (
                                <Typography variant="body2" color="text.secondary" gutterBottom>
                                    <strong>Status:</strong> {uploadResponse.status}
                                </Typography>
                            )}
                            {(uploadResponse.totalOrders !== undefined || uploadResponse.successOrders || uploadResponse.failedOrders) && (
                                <Typography variant="body2" color="text.secondary" gutterBottom>
                                    {uploadResponse.totalOrders !== undefined && (
                                        <>
                                            <strong>Total Orders:</strong> {uploadResponse.totalOrders} | 
                                        </>
                                    )}
                                    {uploadResponse.successOrders && (
                                        <>
                                            <strong> Success:</strong> {uploadResponse.successOrders?.length || 0} | 
                                        </>
                                    )}
                                    <strong> Failed:</strong> {failedOrders.length || uploadResponse.failedOrders?.length || 0}
                                </Typography>
                            )}
                            {uploadResponse.fileName && (
                                <Typography variant="body2" color="text.secondary">
                                    <strong>File:</strong> {uploadResponse.fileName}
                                </Typography>
                            )}
                        </Box>
                    )}
                    {failedOrders.length > 0 && (
                        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><strong>Reference</strong></TableCell>
                                        <TableCell><strong>Reason</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {failedOrders.map((order, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell>{order.reference || 'N/A'}</TableCell>
                                            <TableCell>
                                                <Typography variant="body2" color="error">
                                                    {order.reason || 'Unknown error'}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setErrorDialogOpen(false)} variant="contained" color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default withLayout(() => {
    return (
        <div id="main-content" className="container-fluid">
            <MerchantDeliveryLocations />
        </div>
    );
});
